// extracted by mini-css-extract-plugin
export default {"linkButton":"Link_linkButton__fUq71"};